import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import {
  Toolbar,
  Hidden,
  List,
  ListItem,
  Typography,
  IconButton,
  Button,
} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import { Image } from 'components/atoms';
import { useHistory, Link } from 'react-router-dom';
import { useAppContext } from "libs/contextLib";
import Cookies from 'js-cookie'

const useStyles = makeStyles((theme) => ({
  flexGrow: {
    flexGrow: 1,
  },
  navigationContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  toolbar: {
    zIndex: 999,
    maxWidth: theme.layout.contentWidth,
    width: '100%',
    margin: '0 auto',
    padding: theme.spacing(0, 2),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(0, 8),
    },
  },
  navLink: {
    '&:hover': {
      color: theme.palette.primary.dark,
    },
  },
  listItem: {
    cursor: 'pointer',
    '&:hover > .menu-item, &:hover svg': {
      color: theme.palette.primary.dark,
    },
    '&.menu-item--no-dropdown': {
      paddingRight: 0,
    },
  },
  listItemActive: {
    '&> .menu-item': {
      color: theme.palette.primary.dark,
    },
  },
  listItemText: {
    flex: '0 0 auto',
    marginRight: theme.spacing(2),
    whiteSpace: 'nowrap',
  },
  listItemButton: {
    whiteSpace: 'nowrap',
    marginLeft: '10px',
  },
  listItemIcon: {
    minWidth: 'auto',
  },
  popover: {
    padding: theme.spacing(4),
    border: theme.spacing(2),
    boxShadow: '0 0.5rem 2rem 2px rgba(116, 123, 144, 0.09)',
    minWidth: 350,
    marginTop: theme.spacing(2),
  },
  iconButton: {
    marginLeft: theme.spacing(2),
    padding: 0,
    '&:hover': {
      background: 'transparent',
    },
  },
  expandOpen: {
    transform: 'rotate(180deg)',
    color: theme.palette.primary.dark,
  },
  logoContainer: {
    width: 140,
    height: 28,
    [theme.breakpoints.up('md')]: {
      width: 140,
      height: 32,
    },
  },
  logoImage: {
    width: '150%',
    height: '100%',
  },
  menu: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  menuItem: {
    marginRight: theme.spacing(5),
    '&:last-child': {
      marginRight: 0,
    },
  },
  menuGroupItem: {
    paddingTop: 0,
  },
  menuGroupTitle: {
    textTransform: 'uppercase',
  },
}));

const LoggedOutTopbar = ({
  onSidebarOpen,
  pages,
  className,
  isAuthenticated,
  ...rest
}) => {
  const classes = useStyles();
  const history = useHistory();


  return (
    <Toolbar disableGutters className={classes.toolbar} {...rest}>
      <div className={classes.logoContainer}>
        <a href="/" title="home">
          <Image
            className={classes.logoImage}
            src={
              'https://dial-faster.s3.amazonaws.com/DialFasterLogoCropped.png'
            }
            alt="DialFaster"
            lazy={false}
          />
        </a>
      </div>
      <div className={classes.flexGrow} />
      <Hidden smDown>
        <List disablePadding className={classes.navigationContainer}>
          <ListItem
            className={clsx(classes.listItem, 'menu-item--no-dropdown')}
          >
            <Link to="/pricing" title="pricing">
              <Typography
                variant="body1"
                color="textPrimary"
                className={clsx(classes.listItemText, 'menu-item')}
              >
                PRICING
              </Typography>
            </Link>
            <Link to="/contact" title="thefront">
              <Typography
                variant="body1"
                color="textPrimary"
                className={clsx(classes.listItemText, 'menu-item')}
              >
                CONTACT
              </Typography>
            </Link>
            <Button
              variant="contained"
              color="primary"
              component="a"
              target="blank"
              onClick={() => history.push('/sign-in')}
              className={classes.listItemButton}
            >
              Sign In
            </Button>
          </ListItem>
        </List>
      </Hidden>
      <Hidden mdUp>
        <IconButton
          className={classes.iconButton}
          onClick={onSidebarOpen}
          aria-label="Menu"
        >
          <MenuIcon />
        </IconButton>
      </Hidden>
    </Toolbar>
  );
};

const LoggedInTopbar = ({
  onSidebarOpen,
  pages,
  className,
  isAuthenticated,
  ...rest
}) => {
  const classes = useStyles();
  const history = useHistory();
  const { userHasAuthenticated } = useAppContext();

  // temporary
  async function handleLogout() {
    // await Auth.signOut();
    userHasAuthenticated(false);
    Cookies.remove('access_token')
    history.push("/");
  }



  return (
    <Toolbar disableGutters className={classes.toolbar} {...rest}>
      <div className={classes.logoContainer}>
        <Link to="/" title="home">
          <Typography variant="h4" color="textPrimary">
            RezTeq
          </Typography>
        </Link>
      </div>
      <div className={classes.flexGrow} />
      <Hidden smDown>
        <List disablePadding className={classes.navigationContainer}>
          <ListItem
            className={clsx(classes.listItem, 'menu-item--no-dropdown')}
          >
            <Link to="/logged-in/page-1" title="thefront">
              <Typography
                variant="body1"
                color="textPrimary"
                className={clsx(classes.listItemText, 'menu-item')}
              >
                Page 1
              </Typography>
            </Link>
            <Link to="/logged-in/page-2" title="thefront">
              <Typography
                variant="body1"
                color="textPrimary"
                className={clsx(classes.listItemText, 'menu-item')}
              >
                Page 2
              </Typography>
            </Link>
            <Button
              variant="outlined"
              component="a"
              target="blank"
              onClick={handleLogout}
              className={classes.listItemButton}
            >
              Log Out
            </Button>
          </ListItem>
        </List>
      </Hidden>
      <Hidden mdUp>
        <IconButton
          className={classes.iconButton}
          onClick={onSidebarOpen}
          aria-label="Menu"
        >
          <MenuIcon />
        </IconButton>
      </Hidden>
    </Toolbar>
  );
};

const Topbar = ({
  onSidebarOpen,
  pages,
  className,
  // isAuthenticated,
  ...rest
}) => {
  const classes = useStyles();
  const history = useHistory();

  const { isAuthenticated } = useAppContext();

  return (
    <div>
      {!isAuthenticated ? (
        <LoggedOutTopbar
          onSidebarOpen={onSidebarOpen}
          pages={pages}
          className={className}
        />
      ) : (
        <LoggedInTopbar
          onSidebarOpen={onSidebarOpen}
          pages={pages}
          className={className}
        />
      )}
    </div>
  );
};

Topbar.propTypes = {
  className: PropTypes.string,
  onSidebarOpen: PropTypes.func,
};

export default Topbar;
